export default "__VITE_ASSET__Bz6KdM0v__"